import { PlannerFormModel } from './PlannerFormModel';

const {
    formField: {
        cargo,
        turnos,
        cantidad,
        repeticion,
        diasSemana
    }
} = PlannerFormModel;

export const formInitialValues = {
    [cargo.name]: null,
    [turnos.name]: [],
    [cantidad.name]: 1,
    [repeticion.name]: 'selected', // 'selected', 'range', 'weekdays', 'weekends', 'custom'
    [diasSemana.name]: []
};
